import { Building2, Wallet, PiggyBank, Banknote, Edit3, Trash2 } from "lucide-react";

import { Card } from "@/components/ui/card";
import { cn } from "@/lib/utils";

// FIN-3 — ContaBancariaItem.
// Card horizontal com ícone por tipo, nome+meta e saldo.

const fmtBRL = (v) => Number(v ?? 0).toLocaleString("pt-BR", {
  style: "currency", currency: "BRL",
});

const TYPE_META = {
  checking: { icon: Wallet,     label: "Conta corrente", iconBg: "bg-brand-cyan/15",   iconColor: "text-brand-cyan" },
  savings:  { icon: PiggyBank,  label: "Poupança",       iconBg: "bg-brand-green/15",  iconColor: "text-brand-green" },
  cash:     { icon: Banknote,   label: "Dinheiro",       iconBg: "bg-status-warning/15", iconColor: "text-status-warning" },
  other:    { icon: Building2,  label: "Outro",          iconBg: "bg-foreground-muted/15", iconColor: "text-foreground-muted" },
};

export default function ContaBancariaItem({ account, onEdit, onDelete }) {
  const meta = TYPE_META[account.type] || TYPE_META.other;
  const Icon = meta.icon;
  const bal = Number(account.current_balance ?? 0);
  const balColor = bal >= 0 ? "text-brand-green" : "text-status-error";

  return (
    <Card
      variant="elevated"
      className="glass-card glow-hover p-4 group/conta flex items-center gap-3"
      data-testid={`conta-bancaria-${account.id}`}
    >
      <div className={cn("w-10 h-10 rounded-lg flex items-center justify-center shrink-0", meta.iconBg)}>
        <Icon className={cn("w-5 h-5", meta.iconColor)} aria-hidden="true" />
      </div>

      <div className="flex-1 min-w-0">
        <p className="text-foreground font-semibold truncate">{account.name}</p>
        <p className="text-micro text-foreground-muted truncate">
          {meta.label}{account.institution ? ` · ${account.institution}` : ""}
          {account.is_default ? " · Principal" : ""}
        </p>
      </div>

      <div className={cn("font-mono font-bold text-base tabular-nums shrink-0", balColor)}>
        {fmtBRL(bal)}
      </div>

      <div className="flex items-center gap-1 opacity-0 group-hover/conta:opacity-100 transition-opacity shrink-0">
        <button
          type="button"
          onClick={() => onEdit?.(account)}
          className="p-1.5 rounded-md text-foreground-muted hover:bg-surface-card-hover hover:text-foreground transition-colors"
          aria-label={`Editar ${account.name}`}
          data-testid={`conta-bancaria-${account.id}-edit`}
        >
          <Edit3 className="w-3.5 h-3.5" />
        </button>
        {!account.is_default && (
          <button
            type="button"
            onClick={() => onDelete?.(account)}
            className="p-1.5 rounded-md text-status-error/70 hover:bg-status-error/10 hover:text-status-error transition-colors"
            aria-label={`Apagar ${account.name}`}
            data-testid={`conta-bancaria-${account.id}-delete`}
          >
            <Trash2 className="w-3.5 h-3.5" />
          </button>
        )}
      </div>
    </Card>
  );
}
